import React from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_ID ?? '';
const isProd = process.env.NODE_ENV === 'production';

export const pageviewGA = (url: string) => {
  if (typeof window.gtag === 'function' && isProd) {
    window.gtag('config', GTM_ID, {
      page_path: url,
    });
  }
};

export const eventGA = (action: string, params?: Gtag.EventParams | Gtag.ControlParams | Gtag.CustomParams) => {
  if (typeof window.gtag === 'function' && isProd) {
    window.gtag('event', action, params);
  }
};

export const GoogleTagManagerScript = () => {
  const router = useRouter();

  React.useEffect(() => {
    router.events.on('routeChangeComplete', pageviewGA);
    router.events.on('hashChangeComplete', pageviewGA);
    return () => {
      router.events.off('routeChangeComplete', pageviewGA);
      router.events.off('hashChangeComplete', pageviewGA);
    };
  }, [router.events]);

  return (
    <>
      <Script
        defer
        id="gtm-base"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `,
        }}
      />

      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
    </>
  );
};
